import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";

export const certificateApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getCertificateList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.certificate }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getCertificateById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.certificate }/${ id }`,
		method: 'GET',
	  }),
	}),

	addCertificate: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.certificate }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editCertificate: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.certificate }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteCertificate: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.certificate }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetCertificateListQuery,
  useGetCertificateByIdQuery,
  useAddCertificateMutation,
  useEditCertificateMutation,
  useDeleteCertificateMutation,
  useLazyGetCertificateListQuery
} = certificateApi;
